import React from 'react'
import SliderTopResult from '../../component/slidercomponent/SliderTopResult'

const HomeTopResult = () => {
    return (
        <>
            <div >
                <section className="result" >
                    <div className="container">
                        <div className="sec-title text-center mb-3" data-aos="fade-up" data-aos-duration={1000}>
                            <div className="divider">
                                <span className="fa fa-mortar-board" />
                            </div>
                            <h2>Top Result</h2>
                        </div>
                    </div>
                </section>
                <section className="result-box" >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">Student Name</th>
                                                <th scope="col">Class</th>
                                                <th scope="col">Percentage</th>
                                                <th scope="col">Session</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Krishna Kushwaha</td>
                                                <td>10th</td>
                                                <td>93.4%</td>
                                                <td>2025-26</td>
                                            </tr>
                                            <tr>
                                                <td>SUMAN KUSHWAHA</td>
                                                <td>10th</td>
                                                <td>94%</td>
                                                <td>2024-25</td>
                                            </tr>
                                            <tr>
                                                <td>PARI GUPTA </td>
                                                <td>10th</td>
                                                <td>92.8%</td>
                                                <td>2023-24</td>
                                            </tr>
                                            <tr>
                                                <td>TANISH GUPTA </td>
                                                <td>10th</td>
                                                <td>94.2%</td>
                                                <td>2022-23</td>
                                            </tr>
                                            <tr>
                                                <td>KANISHAK TIWARI </td>
                                                <td>10th</td>
                                                <td>78.4%</td>
                                                <td>2021-22</td>
                                            </tr>
                                            <tr>
                                                <td>MANJEET KUSHWAHA </td>
                                                <td>10th</td>
                                                <td>89%</td>
                                                <td>2020-21</td>
                                            </tr>
                                            <tr>
                                                <td>ADITYA KUSHWAHA </td>
                                                <td>10th</td>
                                                <td>82.66%</td>
                                                <td>2019-20</td>
                                            </tr>
                                            <tr>
                                                <td>JAYDEEP KU. PASWAN </td>
                                                <td>10th</td>
                                                <td>94.4%</td>
                                                <td>2018-19</td>
                                            </tr>
                                            <tr>
                                                <td>SONU KUSHWAHA </td>
                                                <td>10th</td>
                                                <td>82.4%</td>
                                                <td>2017-18</td>
                                            </tr>
                                            <tr>
                                                <td>SHREYA SINGH </td>
                                                <td>10th</td>
                                                <td>70.3%</td>
                                                <td>2016-17</td>
                                            </tr>
                                            <tr>
                                                <td>RAHUL PASWAN </td>
                                                <td>10th</td>
                                                <td>84%</td>
                                                <td>2015-16</td>
                                            </tr>
                                            <tr>
                                                <td>DEEPAK PASWAN </td>
                                                <td>10th</td>
                                                <td>82%</td>
                                                <td>2014-15</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="result-list">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="sec-title mb-3" data-aos="fade-up" data-aos-duration={1000}>
                                    <div className="divider">
                                        <span className="fa fa-mortar-board" />
                                    </div>
                                    <h2>Top Result</h2>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="autoplay">
                                    <SliderTopResult />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <br />
                <br />
            </div>

        </>
    )
}

export default HomeTopResult